import { ChatMessage } from "../../../api/services/chat";

import AIMessage from "./AIMessage";
import UserMessage from "./UserMessage";

const GINO_USER_ID = process.env.REACT_APP_GINO_USER_ID as string;

const GinoMessage = ({ message }: { message: ChatMessage }) => {
  const MESSAGE_TYPE = message.sender_id === Number(GINO_USER_ID) ? "GINO" : "TEXT";
  if (MESSAGE_TYPE === "GINO") return <AIMessage message={message} />;
  if (MESSAGE_TYPE === "TEXT") return <UserMessage message={message} />;
  return null;
};

export default GinoMessage;
